import { WhiteTooltip } from '@AMIEWEB/Common';
import { GridCellParams } from '@mui/x-data-grid';
import React from 'react';
import { useSelector } from 'react-redux';
import { selectEditPreferenceChildrenRows } from 'store/redux-store/placement-mods/selectors';
import { makeStyles } from 'tss-react/mui';
import { getDisplayValue, inValidString } from '../utils';

const StyledTootltip = makeStyles()(theme => ({
  arrow: {
    '&:before': {
      border: '1px solid #E3DFDF',
    },
    color: theme.palette.components.tooltip.arrowColor,
  },
  truncation: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  tooltipContent: {
    backgroundColor: theme.palette.components.tooltip.backgroundColor,
    border: '1px solid #E3DFDF',
    color: theme.palette.system.errorRed,
    fontWeight: 'normal',
  },
}));

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const CustomTooltipCellRenderer = React.memo(function CustomTooltipCellRenderer(cellParams: any) {
  const { classes } = StyledTootltip();

  const editPreferenceChildrenRequests = useSelector(selectEditPreferenceChildrenRows);
  const rowData = getDisplayValue(cellParams.row.id, editPreferenceChildrenRequests);

  const getTitle = row => {
    return inValidString(row?.gender) ? 'Required' : '';
  };

  return (
    <WhiteTooltip
      arrow={true}
      title={getTitle(rowData)}
      classes={{ tooltip: classes.tooltipContent, arrow: classes.arrow }}
    >
      <span style={!rowData?.gender ? { paddingLeft: '40px' } : null} className={classes.truncation}>
        {rowData?.gender ? rowData?.gender : '--'}
      </span>
    </WhiteTooltip>
  );
});

export const ErrorToolTipGender = (params: GridCellParams) => {
  return <CustomTooltipCellRenderer {...params} />;
};
